export default __webpack_public_path__ + "static/media/book5.3e259e24.jpeg";